/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Stagger_Guide_LinkInputs */



/**
* | output |
* | --- |
* | "When does an event become unsanctioned? — Judges' Guide" |
*
* @param {Overview_Stagger_Guide_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_stagger_guide_link = /** @type {((inputs?: Overview_Stagger_Guide_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Stagger_Guide_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quand un événement devient-il non sanctionné ? — Judges' Guide")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cuándo deja de estar sancionado un evento? — Judges' Guide")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Quando um evento deixa de ser sancionado? — Judges' Guide")
	if (locale === "it") return /** @type {LocalizedString} */ ("Quando un evento diventa non sanzionato? — Judges' Guide")
	return /** @type {LocalizedString} */ ("When does an event become unsanctioned? — Judges' Guide")
});